// extracted by mini-css-extract-plugin
export default {"loading-div":"loading_loading-div__Lq8NG","loading":"loading_loading__A2A6-"};